import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class EstimatedProfitsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('EstimatedProfitsError', ...args);
    }
}
export default EstimatedProfitsError;
